$(document).ready(function(){
	init_sticky_navi();

	var menu_overlay_mouseover = false;
	// Set border color
	var active_nav = "";

	$(".ul-nav-container a").mouseover(function(){
		tmp_data = $(this).data('nav');
		$("div.mega-menu").parent().parent().removeClass("d-none").addClass("d-none");
		$("div").find("[data-parent='"+tmp_data+"']").parent().parent().removeClass('d-none');

		active_nav	= $(this).children();
		$(".ul-nav-container a li").removeClass('nav-item-hover')
		
		$(active_nav).addClass('nav-item-hover');
		menu_overlay_mouseover = true;
	}).mouseleave(function(event){
		menu_overlay_mouseover = false;
		setTimeout(function ()
		{
			if (!menu_overlay_mouseover) {
				$("div.mega-menu").parent().parent().addClass('d-none');
				$(active_nav).removeClass('nav-item-hover');
			}
		}, 300);
	});

	$("div.mega-menu").mouseover(function(event){
		$(active_nav).addClass('nav-item-hover');
		menu_overlay_mouseover = true;
	}).mouseleave(function(){
		menu_overlay_mouseover = false;
		setTimeout(function ()
		{
			if (!menu_overlay_mouseover) {
				$("div.mega-menu").parent().parent().addClass('d-none');
				$(active_nav).removeClass('nav-item-hover');
			}
		}, 300);
	});

	$(".mobile-search-icon i").click(function(){
		curr_state = $(".mobile-search").css("display");
		if (curr_state == 'flex') {
			$(".mobile-search").css('display','none');
		}
		if (curr_state == 'none') {
			$(".mobile-search").css('display','flex');
		}
	})

	// mobile-menu
	$(".mobile-menu-icon").click(function(){
		$(".lock-page-container").show();
		$(".mobile-sidebar-scroll-bg").show();
		$(".mobile-sidebar").show();
	})
	$(".lock-page-container").click(function(){
		$(".lock-page-container").hide();
		$(".mobile-sidebar-scroll-bg").hide();
		$(".mobile-sidebar").hide();
	})
	$(".mobile-menu-close-icon").click(function(){
		$(".lock-page-container").hide();
		$(".mobile-sidebar-scroll-bg").hide();
		$(".mobile-sidebar").hide();
	})

	for (i=1;i<=$(".nav-item").length;i++) {
		if ($(".nav-item:nth-child("+i+")").next().children().length > 0) {
			$(".nav-item:nth-child("+i+")").children().next().show();
		}
	}

	$(".expand-item").click(function(){
		item	= $(this);
		item.children().toggleClass("fa-chevron-down");
		item.children().toggleClass("fa-chevron-up");
		item.parent().next().slideToggle(150);
	});

	// Expand active layer
	$(".active-item-burger-menu").each(function(){
		if ($(this).parent().hasClass('nav-item') == true) {
			$(this).next().children().toggleClass("fa-chevron-up");
			$(this).next().children().toggleClass("fa-chevron-down");
			$(this).parent().next().slideToggle(0);
		} else if ($(this).parent().hasClass('nav-sub-item') == true || $(this).parent().hasClass('nav-sub-sub-item') == true) {
			tmp_parent	= $(this).parent().parent().parent().prev().children();
			$(tmp_parent).next().children().toggleClass("fa-chevron-up");
			$(tmp_parent).next().children().toggleClass("fa-chevron-down");
			$(tmp_parent).parent().next().slideToggle(0);
		}
	});
});

// Sticky Navi
function init_sticky_navi(){

	// Show on scroll
	var header_height		= $(".navbar.header").height();
	var sticky_nav_height	= $(".sticky-nav-row").css('height');
	$(window).bind('scroll', function(){
		if ($(window).width() > 1234) {
			if ($(window).scrollTop() > header_height) {
				$(".sticky-nav-row").show();
				$(".container-mega-menu").css({
					'position'	: 'sticky',
					'top'		: sticky_nav_height
				});
			} else {
				$(".sticky-nav-row").hide();
				$(".container-mega-menu").css({
					'position'	: 'relative',
					'top'		: '0'
				});
			}
		}
	})

	// Show Mega-Menu
	var sticky_menu_overlay_mouseover = false;
	// Set border color
	var sticky_active_nav = "";

	$(".ul-sticky-nav-container a").mouseover(function(){
		tmp_data = $(this).data('nav');
		$("div.mega-menu").parent().parent().removeClass("d-none").addClass("d-none");
		$("div").find("[data-parent='"+tmp_data+"']").parent().parent().removeClass('d-none');

		sticky_active_nav	= $(this).children();
		$(".ul-sticky-nav-container a li").removeClass('nav-item-hover')
		
		$(sticky_active_nav).addClass('nav-item-hover');
		sticky_menu_overlay_mouseover = true;
	}).mouseleave(function(event){
		sticky_menu_overlay_mouseover = false;
		setTimeout(function ()
		{
			if (!sticky_menu_overlay_mouseover) {
				$("div.mega-menu").parent().parent().addClass('d-none');
				$(sticky_active_nav).removeClass('nav-item-hover');
			}
		}, 300);
	});

	$("div.mega-menu").mouseover(function(event){
		$(sticky_active_nav).addClass('nav-item-hover');
		sticky_menu_overlay_mouseover = true;
	}).mouseleave(function(){
		sticky_menu_overlay_mouseover = false;
		setTimeout(function ()
		{
			if (!sticky_menu_overlay_mouseover) {
				$("div.mega-menu").parent().parent().addClass('d-none');
				$(sticky_active_nav).removeClass('nav-item-hover');
			}
		}, 300);
	});
}